'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../external/classnames/index.js');

var PropTypes = require('prop-types');

var useMobileBool = require('../../utilities/hooks/useMobileBool.js');

var index$1 = require('../../utilities/GatsbyLink/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var BreadCrumbs = function BreadCrumbs(_ref) {
  var className = _ref.className,
      location = _ref.location,
      homeName = _ref.homeName,
      homeRef = _ref.homeRef,
      hidePath = _ref.hidePath;
  var breadcrumbsClasses = index['default']('breadcrumbs', className);

  var unslugify = function unslugify(string) {
    // .replaceAll() breaks tests because it isn't supported in node
    var search = '-';
    var replacer = new RegExp(search, 'g');
    return string.replace(replacer, ' ');
  };

  var createCrumb = function createCrumb(name, pathname) {
    var link = pathname.substr(0, pathname.indexOf(name)) + name + '/';
    var displayName = unslugify(name);
    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
      key: name
    }, /*#__PURE__*/React__default['default'].createElement(index$1['default'], {
      href: link,
      className: "breadcrumbs-name"
    }, displayName), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "breadcrumbs-divider"
    }, "/"));
  };

  var filterHidden = function filterHidden(hide, crumb) {
    return hide !== null ? crumb.filter(function (n) {
      return n !== hide;
    }) : crumb;
  };

  var renderCrumbs = function renderCrumbs() {
    var pathname = location.pathname;
    var isMobile = useMobileBool.useMobileBool();
    var crumbNames = pathname.split('/').filter(function (i) {
      return i;
    });

    if (isMobile && crumbNames.length > 2) {
      crumbNames = [crumbNames.shift()];
    } else {
      isMobile && crumbNames.pop();
    }

    var altCrumb = filterHidden(hidePath, crumbNames);
    return altCrumb.map(function (name) {
      return createCrumb(name, pathname);
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: breadcrumbsClasses,
    "data-testid": "lanl-breadcrumbs"
  }, /*#__PURE__*/React__default['default'].createElement(index$1['default'], {
    href: homeRef,
    className: "breadcrumbs-name"
  }, homeName), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "breadcrumbs-divider"
  }, "/"), renderCrumbs());
};

BreadCrumbs.defaultProps = {
  homeRef: '/'
};
BreadCrumbs.propTypes = {
  hidePath: PropTypes__default['default'].string,
  homeName: PropTypes__default['default'].string,
  homeRef: PropTypes__default['default'].string,
  location: PropTypes__default['default'].object
};
exports.BreadCrumbs = BreadCrumbs;
exports['default'] = BreadCrumbs;